import { useState } from "react";
import Toast from "@/components/base/Toast";

interface ShareButtonProps {
  title: string;
  className?: string;
}

export default function ShareButton({ title, className = "" }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const helper = document.createElement("textarea");
      helper.value = url;
      helper.setAttribute("readonly", "");
      helper.style.position = "fixed";
      helper.style.opacity = "0";
      document.body.appendChild(helper);
      helper.select();
      document.execCommand("copy");
      document.body.removeChild(helper);
    }
    setCopied(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleCopy}
        className={`inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 ${className}`}
      >
        <i className="ri-links-line text-sm" aria-hidden="true"></i>
        复制链接
      </button>
      <Toast message={`已复制《${title}》的页面链接`} visible={copied} onClose={() => setCopied(false)} />
    </>
  );
}